( function ( $ )
{
    'use strict';
    class SiteAttentionWordPress
    {
        constructor()
        {
            this.domElements = {

                wpContent: document.getElementById( 'wpcontent' )
            }
        }

        /**
         * Gets the post id used as the pid
         * @return int
         */
        getPid()
        {
            return + SiteAttentionInfo.pid;
        }

        /**
         * Returns the iid if set
         * @return string
         */
        getIId()
        {
            return SiteAttentionInfo.iid;
        }

        /**
         * Returns the cms code
         * @return {string} wordpress short code
         */
        getCMS()
        {
            return SiteAttentionModule.Cms.WordPress;
        }

        /**
         * Gets the post type
         * @return string
         */
        getType()
        {
            return SiteAttentionInfo.post_type;
        }

        /**
         * Gets the language from the WP site config or the users navigator language
         * @return string
         */
        getLang()
        {
            return SiteAttentionInfo.language || navigator.language || null;
        }

        /**
         * Gets the user name (technically the wordpress user_login which is unchangeable)
         * @return string
         */
        getUser()
        {
            return SiteAttentionInfo.user_name;
        }

        /**
         * Gets the full link to the post (before saving this isn't available)
         * @return string
         */
        getUrl()
        {
            return SiteAttentionInfo.url;
        }

        /**
         * Gets the publish status
         * @return boolean
         */
        getPublished()
        {
            return SiteAttentionInfo.published === '1';
        }

        /**
         * Gets the fields supplied by the custom_js for mapping
         * @return array
         */
        getMap()
        {
            let fields = [];

            if
            (
                SiteAttentionInfo.post_type === 'post' ||
                SiteAttentionInfo.post_type === 'page'
            )
            {
                fields = [
                    {
                        seo: 'title',
                        name: 'Title',
                        selector: '#title|0',
                        type: 'FieldInput'
                    },
                    {
                        seo: 'url',
                        name: 'Slug',
                        selector: '#post_name|0',
                        type: 'FieldInput',
                    },
                    {
                        seo: 'metadescription',
                        name: 'Excerpt',
                        selector: '#excerpt|0',
                        type: 'FieldInput'
                    },
                    {
                        seo: 'content',
                        name: 'Content',
                        selector: '#content|0',
                        type: 'FieldTinyMCE4'
                    },
                    {
                        seo: 'headers',
                        name: 'Headers',
                        selector: '#content|0',
                        type: 'FieldTinyMCE4'
                    },
                    {
                        seo: 'images',
                        name: 'Images',
                        selector: '#content|0',
                        type: 'FieldTinyMCE4'
                    },
                    {
                        seo: 'videos',
                        name: 'Videos',
                        selector: '#content|0',
                        type: 'FieldTinyMCE4'
                    },
                    {
                        seo: 'links',
                        name: 'Links',
                        selector: '#content|0',
                        type: 'FieldTinyMCE4'
                    },
                ];
            }

            if
            (
                SiteAttentionInfo.post_type === 'post'
            )
            {
                fields.push(
                {
                    seo: 'metakeywords',
                    name: 'Tags',
                    selector: '#tax-input-post_tag|0',
                    type: 'FieldInput'
                } );
            }

            return SiteAttentionModule.FieldFactory( fields );
        }

        /**
         * Add siteattention-on class to the body tag
         * @return
         */
        onShow()
        {
            document.body.classList.add( 'siteattention-on' );
        }

        /**
         * Removes the siteattention-on class from the body tag
         * @return
         */
        onHide()
        {
            document.body.classList.remove( 'siteattention-on' );
        }

        /**
         * Hookd to after minimise
         */
        onMinimise()
        {
            this.domElements.wpContent.style.marginRight = `${0}px`;
        }

        /**
         * Hookd to after maximise
         */
        onMaximise()
        {
            this.domElements.wpContent.style.marginRight = `${350}px`
        }

        /**
         * Trigger keyup event when user is changing the permalink which is the same as the url slug we need
         * @return {[type]} [description]
         */
        permalinkEvent()
        {
            $( '#edit-slug-box' ).click( function ( event )
            {
                let el = document.getElementById( 'post_name' );
                let e = document.createEvent( 'HTMLEvents' );

                e.initEvent( 'keyup', false, true );
                el.dispatchEvent( e );
            } );
        }

        /**
         * Save the SiteAttention iid and license key in Wordpress
         * @param  {boolean}   Request status
         * @param  {string}    The license key
         * @param  {object}    Instance object
         * @return {[type]}    [description]
         */
        saveInformation( status, key, instance )
        {
            if ( !status ) return;

            $.post('/siteattention/settings',JSON.stringify({
                key: key,
                iid: instance.iid,
                iname: instance.name,
                ilocked: instance.locked,
            }),function(data,textStatus,xhr){});
        }

        /**
         * Save the instance information after sign up
         * @param  {boolean} status   Request status
         * @param  {object} instance Instance object
         * @return {[type]}          [description]
         */
        saveInstance( status, instance )
        {
            if ( !status ) return;

            $.post('/siteattention/settings',JSON.stringify({
                iid: instance.iid,
                iname: instance.name,
                ilocked: instance.locked,
            }),function(data,textStatus,xhr){});
        }

        /**
         * Save the instance information after sign up
         * @param  {boolean} status     Request status
         * @param  {string}  key        License key
         * @return {[type]}          [description]
         */
        saveLicense( status, key )
        {
            if ( !status ) return;

            $.post('/siteattention/settings',JSON.stringify({
                key: key,
            }),function(data,textStatus,xhr){});
        }

        /**
         * Adding the SiteAttention score to the sidebar
         */
        setScore( status, data )
        {
            if ( !data ) return;

            let readability = data.readability; //Math.round(data.readability * 10) / 10;
            let score = data.score;

            let html = `
                <div id="siteattention-sidebarscore">
                    <div id="siteattention-readability" class="misc-pub-section siteattention-score">
                        <span class="siteattention-score--logo"></span>
                        <span class="siteattention-score--title">Readability: <b>${readability}</b></span>
                    </div>
                    <div id="siteattention-score" class="misc-pub-section siteattention-score">
                        <span class="siteattention-score--logo"></span>
                        <span class="siteattention-score--title">SEO: <b>${score}%</b></span>
                    </div>
                </div>
            `;

            $( '#siteattention-sidebarscore' ).remove(); // Remove the old
            $( '#misc-publishing-actions' ).append( html );
        }

        /**
         * Returns the wrapper container for SiteAttention
         * @return {div} The div
         */
        getContainer()
        {
            let wpcontent = document.getElementById( 'wpcontent' ),
                container = document.createElement( 'div' );

            wpcontent.style.marginRight = '350px';
            container.id = 'SAPL';

            this.setContainerHeight( container, wpcontent );

            ! function ( setContainerHeight, container, wpcontent )
            {
                window.addEventListener( 'resize', function ( event )
                {
                    setContainerHeight( container, wpcontent )
                } );

            }( this.setContainerHeight, container, wpcontent );

            document.body.appendChild( container );

            return container;
        }

        /**
         * Adjusts the height of the container div
         */
        setContainerHeight( container, wpcontent )
        {
            let wpHtmlContainer = document.querySelector( "html.wp-toolbar" ),
                wpHtmlContainerStyle = window.getComputedStyle( wpHtmlContainer, null ),
                wpHtmlContainerStylePaddingTop = wpHtmlContainerStyle.paddingTop,
                topPos = Number( wpHtmlContainerStylePaddingTop.slice( 0, 2 ) ),
                height = window.innerHeight - topPos;

            container.style.height = `${height}px`;
        }

        /**
         * Initiate SiteAttention script
         */
        init()
        {
            // Show SiteAttention on the page
            SiteAttention.play(
            {
                container: this.getContainer(),
                minimised: false,
            } );

            // Load SiteAttention with the data
            SiteAttention.load( {
                pid:        this.getPid(),
                iid:        this.getIId(),
                cms:        this.getCMS(),
                type:       this.getType(),
                lang:       this.getLang(),
                user:       this.getUser(),
                url:        this.getUrl(),
                published:  this.getPublished(),
                map:        this.getMap(),
            } );

            // Various UI conveniences
            this.onShow();
            this.permalinkEvent();

            // DB saving hooks
            SiteAttentionModule.hooks.add( 'after', 'register', 'Saving client information', ( s, k, i ) => this.saveInformation( s, k, i ) );
            SiteAttentionModule.hooks.add( 'after', 'instance', 'Saving instance data', ( s, i ) => this.saveInstance( s, i ) );
            SiteAttentionModule.hooks.add( 'after', 'license',  'Save existing license', ( s, k, i ) => this.saveInformation( s, k, i ) );

            // UI hooks
            SiteAttentionModule.hooks.add( 'after', 'update',   'UI update', ( s, d ) => this.setScore( s, d ) );
            SiteAttentionModule.hooks.add( 'after', 'minimise', 'Minimise', ( s ) => this.onMinimise( s ) );
            SiteAttentionModule.hooks.add( 'after', 'maximise', 'Maximise', ( s ) => this.onMaximise( s ) );
        }
    };

    $( window ).load( function ()
    {
        if ( typeof SiteAttention !== 'undefined' )
        {
            ( new SiteAttentionWordPress() ).init();
        }
    } );

} )( jQuery );
